export default "__VITE_PUBLIC_ASSET__1929eeff__"